
import React from 'react'
import Auxiliary from  '../../HOC/Auxiliary/Auxiliary';
import Banner from '../../Components/Banner/Banner';
import axios from '../../axios-order';
class Progress extends React.Component{
    state={
        user:{
            token_id:''
        },
        users:{},
        error:{}
    }
    handleUserInput=(e)=>{ 
        const value = e.target.value;
        this.setState({ 
            user:{
            ...this.state.user,
            [e.target.name] : value
            }
        })        
    }
    getUser =()=>{
        axios.get(`/case-search?query=${this.state.user.token_id}`)
        .then(resposne=>{
             this.setState({
                 users : resposne.data.data
             })
        }).catch(error=>{
           this.setState({ error : error })
        })
    }
    render(){
        return(
            <Auxiliary>
                <Banner brand="pgss">
                    <h1 className="bg-text1 mb-1">Progress</h1> 
               </Banner>
               <section>
                    <div className="mx-width">
                        <div className="px-3 py-4">
                            <div className="mb-3">
                                <h4 className="text-color1 text-center heading4">Track your Progress</h4>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-md-6 ">
                                     <div className="form-group">
                                        <label htmlFor="token_id" className="form-label1">Token ID</label>
                                        <input id="token_id"  className="form-control form-input1" type="text"  name="token_id" value={this.state.user.token_id}  onChange={this.handleUserInput}  placeholder="Enter Token" />
                                     </div>
                                     <div className="form-group text-right">
                                        <button type="button" className="btn btn-apply py-2 px-2" onClick={this.getUser}>SUBMIT</button>
                                    </div>
                                </div>                            
                            </div>  
                            <div className="row justify-content-center">
                                <div className="col-md-6 ">
                                       {
                                           Object.entries(this.state.users).length ===0 ? "": 
                                          <div>
                                               <div className="d-flex align-items-center">
                                                    <div className="heading5 mr-2 fw-sb">Name:</div>
                                                    <div>{this.state.users.name}</div>
                                                </div>
                                                <div  className="d-flex align-items-center">
                                                    <div className="heading5 mr-2 fw-sb">Status:</div>
                                                    <div>{this.state.users.status}</div>
                                                </div>
                                          </div>
                                       }
                                </div>                            
                            </div> 
                             
                        </div>
                    </div>
                </section>
          </Auxiliary>
        )
    }
}
export default Progress;